import React, { useState, useEffect } from 'react';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu when a link is clicked
  const handleLinkClick = () => setMenuOpen(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <a href="#hero" className="navbar__logo">
          <img
            src="https://res.cloudinary.com/dsnontai6/image/upload/t_fresh-sold/v1777295844/Fresh_Solution_pvuryz.png"
            alt="Company Logo"
            className="navbar__logo-image"
          />
        </a>

        {/* Desktop links */}
        <ul className="navbar__links">
          <li><a href="#about"    className="navbar__link">About</a></li>
          <li><a href="#services" className="navbar__link">Services</a></li>
          <li><a href="#why"      className="navbar__link">Why Us</a></li>
          <li><a href="#contact"  className="navbar__link navbar__link--cta">Contact</a></li>
        </ul>

        {/* Hamburger button */}
        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className="navbar__hamburger-bar" />
          <span className="navbar__hamburger-bar" />
          <span className="navbar__hamburger-bar" />
        </button>
      </nav>

      {/* Mobile drawer overlay */}
      <div
        className={`navbar__overlay ${menuOpen ? 'navbar__overlay--visible' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      {/* Mobile drawer */}
      <div className={`navbar__drawer ${menuOpen ? 'navbar__drawer--open' : ''}`}>
        <ul className="navbar__drawer-links">
          <li><a href="#about"    className="navbar__drawer-link" onClick={handleLinkClick}>About</a></li>
          <li><a href="#services" className="navbar__drawer-link" onClick={handleLinkClick}>Services</a></li>
          <li><a href="#why"      className="navbar__drawer-link" onClick={handleLinkClick}>Why Us</a></li>
          <li><a href="#contact"  className="navbar__drawer-link navbar__drawer-link--cta" onClick={handleLinkClick}>Contact</a></li>
        </ul>
      </div>
    </>
  );
}